import styled, { css } from 'styled-components';
import { theme } from 'types';

export const Row = styled.div<theme.TGapOption & theme.TGridJustifyAlign>`
    display: grid;
    grid-auto-flow: row;
    //justify-content: center;
    //align-items: center;
    ${({ theme }) => theme.mixins.gapOption};
    ${({ theme }) => theme.mixins.gridJustifyAlign};
`;

export const Col = styled.div<theme.TGapOption & theme.TGridJustifyAlign>`
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    //justify-content: center;
    //align-items: center;
    ${({ theme }) => theme.mixins.gapOption};
    ${({ theme }) => theme.mixins.gridJustifyAlign};
`;

export const Center = styled.div<{
    grid?: boolean;
    vertOnly?: boolean;
    horizOnly?: boolean;
}>`
    display: flex;

    ${({ vertOnly, horizOnly }) => {
        return vertOnly
            ? css`
                  align-items: center;
              `
            : horizOnly
            ? css`
                  justify-content: center;
              `
            : css`
                  justify-content: center;
                  align-items: center;
              `;
    }};
`;
